/** Lista de atendimentos do teleconsultor: de onde a tela do parecer é aberta e para onde volta. */
export const LISTA_ATENDIMENTOS = '/apps/atendimentosMedicos/lista'

/** Tela do parecer, para a lista e o teleatendimento levarem até ela. */
export const rotaParecerInterconsulta = (atendimentoId: number | string) =>
  `/apps/atendimentosMedicos/parecer/${atendimentoId}`
